var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.promotionByHarel && !_vm.showSavingZone)?_c('navigation-button',{attrs:{"on-click":_vm.onClick,"button-text":"חיסכון בקופת גמל להשקעה"}},[_c('img',{attrs:{"src":require('@/assets/nav/trophy.svg')}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }